module.exports = __webpack_public_path__ + "static/media/pasirris-back.253e76c2.png";